export { default } from './Navigation'

/**
 * Should the component only render server side?
 * You can set this to true if the component is a pure static component.
 */
export const ONLY_SERVER = false